import * as React from "react";
import { connect } from "react-redux";

import { getCoupon as getCouponAction } from "../../actions";
import {
  CouponCode as CouponCodeComponent,
  CouponCodeProps,
} from "../../components/CouponCode/CouponCode";
import { StoreState } from "../../reducers";
import {
  getCampaignId,
  getCoupon,
  getMerchantId,
} from "../../reducers/methods";
import get from "lodash/get";

const maxRetries = 30;
const waitTime = 500;

interface CouponContainerProps extends CouponCodeProps {
  getCouponAction: typeof getCouponAction;
  campaignId: string;
  merchantId: string;
  eventType: string;
  couponObject: ReturnType<typeof getCoupon>;
}

interface CouponContainerState {
  retryCount: number;
  status: "pulling" | "timeout";
}
class CouponCode extends React.Component<
  CouponContainerProps,
  CouponContainerState
> {
  constructor(props: CouponContainerProps) {
    super(props);
    this.state = { retryCount: 0, status: "pulling" };
  }

  componentDidMount() {
    setTimeout(this.pollCoupon, waitTime);
  }

  pollCoupon = () => {
    if (this.state.retryCount === maxRetries) {
      this.setState({ status: "timeout" });

      return;
    }

    if (
      this.state.retryCount < maxRetries &&
      this.props.couponObject.status === "pending"
    ) {
      this.props.getCouponAction({
        campaignId: this.props.campaignId,
        eventType: this.props.eventType || "email_capture",
        email: get(this.props, "data.customer.email"),
      });
      this.setState({
        retryCount: this.state.retryCount + 1,
      });
      setTimeout(this.pollCoupon, waitTime);
    }
  };

  render() {
    const { couponObject } = this.props;

    let status = couponObject.status;

    if (status !== "success" && this.state.status === "timeout") {
      status = "timeout";
    }

    return (
      <CouponCodeComponent
        {...this.props}
        status={status}
        coupon={couponObject.coupon}
      />
    );
  }
}

function mapStateToProp(state: StoreState, props: CouponContainerProps) {
  return {
    couponObject: getCoupon(state),
    merchantId: getMerchantId(state),
    campaignId: getCampaignId(state),
  };
}

export default connect(mapStateToProp, { getCouponAction })(CouponCode);
